import React from 'react';
export function FraseFinalSection() {
  return <section className="bg-[#000000] py-20 md:py-32 px-4" data-id="element-64">
      <div className="max-w-4xl mx-auto text-center" data-id="element-65">
        <blockquote className="space-y-6" data-id="element-66">
          <p className="text-3xl md:text-5xl font-light text-white leading-tight" data-id="element-67">
            "Primero ves la fuga.
          </p>
          <br data-id="element-68" />
          <p className="text-3xl md:text-5xl font-bold text-[#D90B10] leading-tight" data-id="element-69">
            Después diseñas el crecimiento."
          </p>
        </blockquote>
      </div>
    </section>;
}